import { ApplicationError } from '@/src/shared/errors';

export class SendMessageFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal mengirim pesan. Silakan coba lagi.');
  }
}

export class GetMessagesFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memuat pesan. Silakan coba lagi.');
  }
}

export class GetContactFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memuat kontak. Silakan coba lagi.');
  }
}

export class GetConversationsFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memuat percakapan. Silakan coba lagi.');
  }
}

export class GetAccountFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal memuat akun. Silakan coba lagi.');
  }
}

export class CreateAccountFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal membuat akun. Silakan coba lagi.');
  }
}

export class CreateConversationFailedError extends ApplicationError {
  constructor() {
    super('Error', 'Gagal membuat percakapan. Silakan coba lagi.');
  }
}

export class UpdateLastSeenFailedError extends ApplicationError {
  constructor() {
    super(
      'Error',
      'Gagal memperbarui status terakhir dilihat. Silakan coba lagi.'
    );
  }
}
